import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
class StepFinal extends Component {
    constructor(props){
        super(props);
    }
    
    render(){
        return(<div>
            <div className="form-row">
                <div className="col-md-12 form-group">
                    <div className="lowerPartTitle">
                        <h4><Trans>Thank you for applying for school meal benefits!</Trans></h4>
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="col-md-12">
                    <div className="alert alert-success bg-color-2">
                        <p><strong><Trans>Your application has been submitted</Trans>.</strong></p>
                        <p><Trans>You will hear from us soon with your certification decision!</Trans></p>
                    </div>
                </div>
            </div>
            </div>)
    }
}
export default StepFinal


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolLunchBreakfastProgram/stepFinal.jsx